import { cn } from "@/lib/utils/cn";

export function Logo({
  className,
  showWordmark = true,
  invert = false,
}: {
  className?: string;
  showWordmark?: boolean;
  invert?: boolean;
}) {
  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <div
        aria-hidden
        className={cn(
          "flex h-9 w-9 items-center justify-center rounded-xl text-[14px] font-bold leading-none tracking-tight shadow-soft",
          invert ? "bg-white text-brand-600" : "bg-brand-grad text-white"
        )}
      >
        iG
      </div>
      {showWordmark && (
        <div className="flex flex-col leading-[0.85]">
          <span
            className={cn(
              "text-[16px] font-bold tracking-tight",
              invert ? "text-white" : "text-ink",
            )}
          >
            Imob<span className={invert ? "text-brand-400" : "text-brand-600"}>Go</span>
          </span>
          <span className={cn(
            "text-[9px] font-bold uppercase tracking-[0.2em] opacity-60",
            invert ? "text-white" : "text-ink-muted"
          )}>
            Agency
          </span>
        </div>
      )}
    </div>
  );
}
